import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../portalV2Shared.css';
import './ModalErrorV2.css';
import './ModalConfirmV2.css';

/**
 * Portal V2 confirm modal — glass / gold, two actions.
 * Classic ModalSevenConfirm stays untouched.
 */
export default function ModalConfirmV2({
    show,
    onClose,
    title = 'Ready to continue?',
    description = '',
    cancelLabel = 'Keep editing',
    confirmLabel = 'Yes, continue',
    onConfirm,
}) {
    useEffect(() => {
        if (!show) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prev;
        };
    }, [show, onClose]);

    if (!show || typeof document === 'undefined') return null;

    return createPortal(
        <div
            className="pv2-modal-error"
            role="dialog"
            aria-modal="true"
            aria-labelledby="pv2-modal-confirm-title"
        >
            <div
                className="pv2-modal-error__backdrop"
                aria-hidden="true"
                onClick={onClose}
            />
            <div className="pv2-modal-error__card pv2-modal-confirm__card">
                <div className="pv2-modal-error__head">
                    <div>
                        <p className="pv2-modal-error__eyebrow">Top 7</p>
                        <h2
                            id="pv2-modal-confirm-title"
                            className="pv2-modal-error__title"
                        >
                            {title}
                        </h2>
                    </div>
                    <button
                        type="button"
                        className="pv2-modal-error__close"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                {description ? (
                    <p className="pv2-modal-error__desc">{description}</p>
                ) : null}
                <div className="pv2-modal-confirm__actions">
                    <button
                        type="button"
                        className="pv2-modal-confirm__secondary"
                        onClick={onClose}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className="pv2-modal-error__ok"
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
